/**
 * Media Player device action preparations
 */

import type {
	DeviceActionContext,
	PreparedDeviceAction,
} from 'src/components/Scenes/helpers/device_actions/types';

/**
 * Prepares action payload for media player devices.
 *
 * @param context - Context containing shared helpers and queued device actions.
 * @returns Prepared action payload ready for dispatch to the device.
 */
export const prepareMediaPlayerAction = (context: DeviceActionContext): PreparedDeviceAction => {
	const { hexToDecimal, actions } = context;

	const action: PreparedDeviceAction = {
		_gui_purpose: 'action',
		r: 'dev:' + hexToDecimal + ':' + actions[0].name,
	};

	const actionValue = actions[0]?.value;
	const set = {
		...(typeof actionValue === 'object' ? actionValue : {}),
		_isdata: true,
	};

	action.set = set;

	return action;
};
